export enum RequestType {
  PBH = 1,
  RBH = 2,
}
